import { render } from "./OfferAndPrivacyPolicyScreen.vue?vue&type=template&id=f37194bc&scoped=true"
const script = {}

import "./OfferAndPrivacyPolicyScreen.vue?vue&type=style&index=0&id=f37194bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37194bc"]])

export default __exports__